import PropTypes from 'prop-types';
import React, { Component } from 'react';
import {SportHomePageContent} from "../../Common/pages/SportHomePageContent";

export default class DartsHomePage extends Component {
  static propTypes = {
    children: PropTypes.node
  };

  render() {
    const { location } = this.props;

    return <SportHomePageContent
      sport="darts"
      title="Darts News, Results & Betting"
      location={ location }
    />
  }
}



// WEBPACK FOOTER //
// ./modules/Darts/containers/DartsHomePage.js